import PropTypes from 'prop-types';
import React from 'react';
import RadioGroup from './index';

export default function renderRadioGroup({ input, meta: { touched, error, warning }, ...args }) {
  const validationMessage = touched ? error || warning : null;
  const isValid = !(error || warning);
  const id = args.id || input.name || null;

  return (
    <RadioGroup
      selectedValue={input.value}
      validationMessage={validationMessage}
      isValid={isValid}
      id={id}
      {...args}
      {...input}
    />
  );
}

renderRadioGroup.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    warning: PropTypes.string,
  }),
};
